import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HlmAlertDialogImports } from '@spartan-ng/helm/alert-dialog';
import { AppUpdateService } from './app-update.service';

/** Single hlm-alert-dialog host for AppUpdateService's update/reload prompts. */
@Component({
  selector: 'elite-app-update-prompt',
  imports: [HlmAlertDialogImports],
  template: `
    @let pending = appUpdateService.prompt();
    <hlm-alert-dialog [state]="pending ? 'open' : 'closed'" (stateChanged)="onState($event)">
      <hlm-alert-dialog-content *hlmAlertDialogPortal data-testid="app-update-prompt-dialog">
        <hlm-alert-dialog-header>
          <h3 hlmAlertDialogTitle>{{ pending?.header }}</h3>
          <p hlmAlertDialogDescription>{{ pending?.message }}</p>
        </hlm-alert-dialog-header>
        <hlm-alert-dialog-footer>
          @if (pending?.rejectLabel) {
            <button hlmAlertDialogCancel (click)="onReject()" data-testid="app-update-prompt-reject">
              {{ pending?.rejectLabel }}
            </button>
          }
          <button hlmAlertDialogAction (click)="onAccept()" data-testid="app-update-prompt-accept">
            {{ pending?.acceptLabel }}
          </button>
        </hlm-alert-dialog-footer>
      </hlm-alert-dialog-content>
    </hlm-alert-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdatePromptComponent {
  protected readonly appUpdateService = inject(AppUpdateService);

  onState(state: 'open' | 'closed'): void {
    if (state === 'closed') {
      this.appUpdateService.prompt.set(null);
    }
  }

  onAccept(): void {
    this.appUpdateService.prompt()?.accept();
  }

  onReject(): void {
    this.appUpdateService.prompt()?.reject?.();
  }
}
